import React from 'react';
import Notification from '../Notification.js';


class CustomCss extends React.Component {
    constructor(props) {
        super(props);   

        this.state = {

        }     

    }

    componentDidMount() {
        $(this.refs.modal).modal('show');
    }

    render() {
        
        return (
            <div ref="modal" className="modal fade modal-fade-in-scale-up" id="aaa" aria-hidden="true" role="dialog" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content" style={{height:'1000px'}}>
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title">Custom CSS</h4>
                        </div>
                        <div className="modal-body">
                            <textarea className="form-control" style={{width:'100%','height':'100%'}}  />
                        </div>
                        
                    </div>
                </div>
            </div>
        );
    }

  
}

export default CustomCss;






// WEBPACK FOOTER //
// ./components/builder/CustomCss.js